'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalAction = function ModalAction(props) {
  var closeAfterClick = props.closeAfterClick,
      closeModal = props.closeModal,
      onClick = props.onClick;

  var handleClick = function handleClick(e) {
    if (onClick) {
      onClick(e);
    }
    if (closeAfterClick) {
      closeModal(e);
    }
  };
  var buttonProps = Object.assign({}, props, { onClick: handleClick });
  return _react2.default.createElement(_.Button, buttonProps);
};

ModalAction.propTypes = {
  closeAfterClick: _propTypes2.default.bool,
  closeModal: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};

exports.default = ModalAction;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Modal/ModalAction.js